import { render, staticRenderFns } from "./custom-company-cooperation.vue?vue&type=template&id=1d2c8f9a&scoped=true&"
import script from "./custom-company-cooperation.vue?vue&type=script&lang=js&"
export * from "./custom-company-cooperation.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-cooperation.vue?vue&type=style&index=0&id=1d2c8f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c8f9a",
  null
  
)

export default component.exports